<template>
  <div class="wrapBox" style=" padding-left:4px;padding-right:8px;padding-top:8px;  ">
    <div class="yearInfo" style="height:310px; background-color: #1a1e29;">
      <div class="myChartTitleWrap">
        <div class="myChartTitle">{{titleText}}</div>
      </div>
      <div>
        <el-row>
          <el-col :span="24">
            <div class="lybk_green">
              <div class="lybk_title"><span>累计出口额</span> </div>
              <div class="lybk_number"><span class="lybk_number_number">{{mainPageData.eSum}}</span><span class="lybk_number_unit">&nbsp;亿元</span></div>
            </div></el-col>
          <el-col :span="24">
            <div class="lybk_blue">
              <div class="lybk_title"><span>累计进口额</span> </div>
              <div class="lybk_number"><span class="lybk_number_number">{{mainPageData.iSum}}</span><span class="lybk_number_unit">&nbsp;亿元</span></div>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <div class="lybk_red">
              <div class="lybk_title"><span>累计出口平均额</span> </div>
              <div class="lybk_number"><span class="lybk_number_number">{{mainPageData.eAvg}}</span><span class="lybk_number_unit">&nbsp;元</span></div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="lybk_purple">
              <div class="lybk_title"><span>累计进口平均额</span> </div>
              <div class="lybk_number"><span class="lybk_number_number">{{mainPageData.iAvg}}</span><span  class="lybk_number_unit">&nbsp;元</span></div>
            </div>
          </el-col>
        </el-row> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      titleText: '累计进出口额实时数据（截至'+ this.mainPageData.dataEnd +'）',
      textStyle: {color:'#ccc', fontStyle:'normal', fontWeight:'bold', fontFamily:'sans-serif', fontSize:12 },
      legendPadding: [65, 5, 15, 5]
    }
  },
  props: ['mainPageData'],
  mounted() {
    
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .yearInfo table {
  padding-top: 30px;
  padding-left: 40px;
  font-size: 16px;
  color: white;
}
.yearInfo tr {
  line-height: 35px;
}

.yearInfo  .haha {
  padding-top: 0px;
  padding-left: 00px;
  font-size: 16px;
  color: yellow;
} */

</style>



// WEBPACK FOOTER //
// src/components/LastYearInfo.vue